import { QuestionCore } from '../../types'

export const SPELLINGWW_QUESTIONS: QuestionCore[] = [
  // EXISTING QUESTIONS
  {
    id: 'WW-L1-001',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_tegenwoordige_tijd',
    familyId: 'WW-TT-BLAFFEN',
    difficulty: 1,
    question: 'Vul in: De hond ..... (blaffen) hard naar de postbode.',
    options: ['blaft', 'blafd', 'blafdt', 'blaf'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L1-002',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_tegenwoordige_tijd',
    familyId: 'WW-TT-VINDEN',
    difficulty: 1,
    question: 'Vul in: Ik ..... (vinden) deze film erg spannend.',
    options: ['vind', 'vindt', 'vint', 'vinde'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L2-001',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_verleden_tijd',
    familyId: 'WW-VT-FIETSEN',
    difficulty: 2,
    question:
      'Verleden tijd: De kinderen ..... (fietsen) gisteren naar het park.',
    options: ['fietsten', 'fietstten', 'fietsen', 'fietste'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L2-002',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_tegenwoordige_tijd',
    familyId: 'WW-TT-LOPEN',
    difficulty: 2,
    question: 'Vul in: ..... (lopen) jij even mee naar de winkel?',
    options: ['Loop', 'Loopt', 'Lope', 'Liep'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L2-003',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_tegenwoordige_tijd',
    familyId: 'WW-TT-BRANDEN',
    difficulty: 2,
    question: 'Vul in: ..... (branden) het licht in de gang?',
    options: ['Brandt', 'Brand', 'Brande', 'Brandde'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L3-001',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_voltooid_deelwoord',
    familyId: 'WW-VD-REDDEN',
    difficulty: 3,
    question:
      'Voltooid deelwoord: De brandweer heeft de kat uit de boom ..... (redden).',
    options: ['gered', 'geredt', 'geredde', 'redde'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L3-002',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_tegenwoordige_tijd',
    familyId: 'WW-TT-WORDEN',
    difficulty: 3,
    question: 'Vul in: De taart ..... (worden) door de bakker versierd.',
    options: ['wordt', 'word', 'worddt', 'werden'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L3-003',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_verleden_tijd',
    familyId: 'WW-VT-GEBEUREN',
    difficulty: 3,
    question: 'Vul in: Het ..... (gebeuren) gisteren vlak voor mijn neus.',
    options: ['gebeurde', 'gebeurden', 'gebeurt', 'gebeurd'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L1-003',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_tegenwoordige_tijd',
    familyId: 'WW-TT-MAKEN',
    difficulty: 1,
    question: 'Vul in: Zij ..... (maken) haar huiswerk netjes.',
    options: ['maakt', 'make', 'maak', 'maakd'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L1-004',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_tegenwoordige_tijd',
    familyId: 'WW-TT-WERKEN',
    difficulty: 1,
    question: 'Vul in: Jij ..... (werken) vandaag heel hard.',
    options: ['werkt', 'werk', 'werkte', 'werkd'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L1-005',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_tegenwoordige_tijd',
    familyId: 'WW-TT-SPELEN',
    difficulty: 1,
    question: 'Vul in: Mijn broer ..... (spelen) vaak buiten.',
    options: ['speelt', 'speel', 'spelend', 'speelde'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L2-004',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_verleden_tijd',
    familyId: 'WW-VT-LEREN',
    difficulty: 2,
    question: 'Verleden tijd: Wij ..... (leren) gisteren voor de toets.',
    options: ['leerden', 'leerde', 'leren', 'geleerd'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L2-005',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_verleden_tijd',
    familyId: 'WW-VT-SPRINGEN',
    difficulty: 2,
    question: 'Verleden tijd: De hond ..... (springen) over het hek.',
    options: ['sprong', 'sprongen', 'springde', 'springt'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L2-006',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_tegenwoordige_tijd',
    familyId: 'WW-TT-KOMEN',
    difficulty: 2,
    question: 'Vul in: ..... (komen) jullie morgen ook?',
    options: ['Komen', 'Komt', 'Kwam', 'Gekomen'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L3-004',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_voltooid_deelwoord',
    familyId: 'WW-VD-LATEN',
    difficulty: 3,
    question: 'Voltooid deelwoord: Ik heb mijn tas thuis ..... (laten).',
    options: ['gelaten', 'gelat', 'laat', 'liet'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L3-005',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_voltooid_deelwoord',
    familyId: 'WW-VD-EINDIGEN',
    difficulty: 3,
    question: 'Voltooid deelwoord: De wedstrijd is vroeg ..... (eindigen).',
    options: ['geëindigd', 'geëindigt', 'eindigde', 'eindigt'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L3-006',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_verleden_tijd',
    familyId: 'WW-VT-WORDEN',
    difficulty: 3,
    question: 'Vul in: De brief ..... (worden) gisteren verstuurd.',
    options: ['werd', 'wordt', 'worden', 'geworden'],
    correctAnswer: 0,
  },

  // NIEUW: TEGENWOORDIGE TIJD (L1)
  {
    id: 'WW-L1-006',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_tegenwoordige_tijd',
    familyId: 'WW-TT-FIETSEN',
    difficulty: 1,
    question: 'Vul in: Hij ..... (fietsen) naar school.',
    options: ['fietst', 'fiets', 'fietstt', 'fietsd'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L1-007',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_tegenwoordige_tijd',
    familyId: 'WW-TT-SCHIJNEN',
    difficulty: 1,
    question: 'Vul in: De zon ..... (schijnen) fel.',
    options: ['schijnt', 'schijn', 'schijndt', 'scheen'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L1-008',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_tegenwoordige_tijd',
    familyId: 'WW-TT-LOPEN-WIJ',
    difficulty: 1,
    question: 'Vul in: Wij ..... (lopen) naar huis.',
    options: ['lopen', 'loop', 'loopt', 'liepen'],
    correctAnswer: 0,
  },

  // NIEUW: VERLEDEN TIJD (L2)
  {
    id: 'WW-L2-007',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_verleden_tijd',
    familyId: 'WW-VT-WERKEN',
    difficulty: 2,
    question: 'Verleden tijd: De man ..... (werken) in de tuin.',
    options: ['werkte', 'werkten', 'werkt', 'gewerkt'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L2-008',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_verleden_tijd',
    familyId: 'WW-VT-MAKEN',
    difficulty: 2,
    question: 'Verleden tijd: Wij ..... (maken) een mooie tekening.',
    options: ['maakten', 'maakte', 'maken', 'gemaakt'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L2-009',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_verleden_tijd',
    familyId: 'WW-VT-REGENEN',
    difficulty: 2,
    question: 'Verleden tijd: Het ..... (regenen) de hele dag.',
    options: ['regende', 'regenden', 'regent', 'geregend'],
    correctAnswer: 0,
  },

  // NIEUW: VOLTOOID DEELWOORD (L3)
  {
    id: 'WW-L3-007',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_voltooid_deelwoord',
    familyId: 'WW-VD-SCHRIJVEN',
    difficulty: 3,
    question: 'Voltooid deelwoord: Ik heb de brief ..... (schrijven).',
    options: ['geschreven', 'geschrijft', 'schreef', 'schrijven'],
    correctAnswer: 0,
  },
  {
    id: 'WW-L3-008',
    module: 'SpellingWW',
    questionType: 'multiple_choice',
    skill: 'spelling',
    subSkill: 'werkwoord_voltooid_deelwoord',
    familyId: 'WW-VD-ETEN',
    difficulty: 3,
    question: 'Voltooid deelwoord: Wij hebben lekker ..... (eten).',
    options: ['gegeten', 'geëten', 'aten', 'eten'],
    correctAnswer: 0,
  },
]
